// import { WORKOUT_EXERCISE_CLASS_NAME } from '../../workout-exercise/model/constants'

const REDUX_NON_SAVABLE_ASSOCIATION = {
  // [WORKOUT_EXERCISE_CLASS_NAME]: WORKOUT_EXERCISES_NON_SAVABLE_ASSOCIATIONS
}

export default REDUX_NON_SAVABLE_ASSOCIATION
